import { useFieldHelper } from 'framework/ui/field';
import IconButton from '@mui/material/IconButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { SearchResultAttachmentsListField } from 'domain/shared/artifact/field';
import { CHANGE_REQUEST_STATUS, useNewProjectUrl } from 'domain/shared/newProject';
import { openPageInNewTab } from 'framework/utils';

interface SourceFieldProps {
  projectId: string;
  statusSource: string;
  idSource: string;
  afsArtifactId: string;
}

const SourceField = ({ projectId, statusSource, idSource, afsArtifactId }: SourceFieldProps) => {
  const { getValue: getStatusValue } = useFieldHelper({ source: statusSource });
  const { getValue: getIdValue } = useFieldHelper({ source: idSource });
  const { getValue: getafsArtifactIdValue } = useFieldHelper({ source: afsArtifactId });
  const { getUpdateChangeRequestUrl } = useNewProjectUrl();
  const status = getStatusValue();
  const requestId = getIdValue();

  return (
    <>
      {(status === CHANGE_REQUEST_STATUS.DRAFT || status === CHANGE_REQUEST_STATUS.REJECTED) && (
        <IconButton
          onClick={() => openPageInNewTab(getUpdateChangeRequestUrl(projectId, requestId))}
          data-testid="update-button"
        >
          <AppRegistrationIcon color="primary" />
        </IconButton>
      )}

      {status === CHANGE_REQUEST_STATUS.SIGNED && (
        <SearchResultAttachmentsListField source="" value={[getafsArtifactIdValue()]} />
      )}
    </>
  );
};
export default SourceField;
